export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const VENDOR_LOGIN = 'VENDOR_LOGIN'
export const CLEAN_VENDOR_LOGIN = 'CLEAN_VENDOR_LOGIN'

export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS'
export const REFRESH_TOKEN_ERROR = 'REFRESH_TOKEN_ERROR'

export const LOGOUT = 'LOGOUT'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_ERROR = 'LOGOUT_ERROR'

// for showing progress/onloading
export const FETCHING = 'FETCHING'
export const FETCH_COMPLETE = 'FETCH_COMPLETE'

export const APPEND_SNACKBAR = 'APPEND_SNACKBAR'
export const SET_SNACKBAR = 'SET_SNACKBAR'
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR'
export const SET_VENDOR_LOGIN_STATE = 'SET_VENDOR_LOGIN_STATE'

export const START_LANDING_FETCH = 'START_LANDING_FETCH'
export const SET_LANDING_FETCH_STATE = 'SET_LANDING_FETCH_STATE'

// cream item related
export const CREATE_CREAM_ITEM = 'CREATE_CREAM_ITEM'
export const CREATE_CREAM_ITEM_SUCCESS = 'CREATE_CREAM_ITEM_SUCCESS'
export const CREATE_CREAM_ITEM_ERROR = 'CREATE_CREAM_ITEM_ERROR'

export const TERMINATE_CREAM_ITEM = 'TERMINATE_CREAM_ITEM'
export const TERMINATE_CREAM_ITEM_SUCCESS = 'TERMINATE_CREAM_ITEM_SUCCESS'
export const TERMINATE_CREAM_ITEM_ERROR = 'TERMINATE_CREAM_ITEM_ERROR'

export const GET_SLASH_INFO = 'GET_SLASH_INFO'
export const GET_SLASH_INFO_SUCCESS = 'GET_SLASH_INFO_SUCCESS'
export const GET_SLASH_INFO_ERROR = 'GET_SLASH_INFO_ERROR'

// SMS
export const SEND_SMS = 'SEND_SMS'
export const SEND_SMS_SUCCESS = 'SEND_SMS_SUCCESS'
export const SEND_SMS_ERROR = 'SEND_SMS_ERROR'

export const CONFIRM_SMS = 'CONFIRM_SMS'
export const CONFIRM_SMS_SUCCESS = 'CONFIRM_SMS_SUCCESS'
export const CONFIRM_SMS_ERROR = 'CONFIRM_SMS_ERROR'

export const CONFIRM_USER_INFO = 'CONFIRM_USER_INFO'
export const SMS_REDIRECT_TO_LOGIN = 'SMS_REDIRECT_TO_LOGIN'

export const LOCK_SEND_SMS = 'LOCK_SEND_SMS'

export const MOVE_CREATED_ITEM_TO_LIST = 'MOVE_CREATED_ITEM_TO_LIST'
export const MARK_CREATED_ITEM_SHOWN = 'MARK_CREATED_ITEM_SHOWN'

// tappay
export const LOAD_TAPPAY_SDK = 'LOAD_TAPPAY_SDK'
export const LOAD_TAPPAY_SDK_SUCCESS = 'LOAD_TAPPAY_SDK_SUCCESS'
export const LOAD_TAPPAY_SDK_ERROR = 'LOAD_TAPPAY_SDK_ERROR'
export const CHECKOUT_TAPPAY = 'CHECKOUT_TAPPAY'
export const CHECKOUT_TAPPAY_SUCCESS = 'CHECKOUT_TAPPAY_SUCCESS'
export const CHECKOUT_TAPPAY_ERROR = 'CHECKOUT_TAPPAY_ERROR'

export const CLEAR_PURCHASE_RESULT = 'CLEAR_PURCHASE_RESULT'

// 取得實際提領金額相關資訊
export const CALCULATE_WITHDRAW = 'CALCULATE_WITHDRAW'
export const CALCULATE_WITHDRAW_SUCCESS = 'CALCULATE_WITHDRAW_SUCCESS'
export const CALCULATE_WITHDRAW_ERROR = 'CALCULATE_WITHDRAW_ERROR'

// 申請提領
export const MAKE_WITHDRAW = 'MAKE_WITHDRAW'
export const MAKE_WITHDRAW_SUCCESS = 'MAKE_WITHDRAW_SUCCESS'
export const MAKE_WITHDRAW_ERROR = 'MAKE_WITHDRAW_ERROR'

// 提領成功後頁面跳轉開關
export const RESET_WITHDRAW_SUCCEEDED = 'RESET_WITHDRAW_SUCCEEDED'

// 提領動畫
export const MARK_WITHDRAW_SHOWN = 'MARK_WITHDRAW_SHOWN'

// 取得購買連結資訊
export const GET_ITEM_ENTRY_INFO = 'GET_ITEM_ENTRY_INFO'
export const GET_ITEM_ENTRY_INFO_SUCCESS = 'GET_ITEM_ENTRY_INFO_SUCCESS'
export const GET_ITEM_ENTRY_INFO_ERROR = 'GET_ITEM_ENTRY_INFO_ERROR'

// 取得逾期款項付款資訊
export const GET_BUYER_INSTALMENTS_INFO = 'GET_BUYER_INSTALMENTS_INFO'
export const GET_BUYER_INSTALMENTS_INFO_SUCCESS =
  'GET_BUYER_INSTALMENTS_INFO_SUCCESS'
export const GET_BUYER_INSTALMENTS_INFO_ERROR =
  'GET_BUYER_INSTALMENTS_INFO_ERROR'

// 取得逾期定期定額付款資訊
export const GET_BUYER_PERIODIC_INFO = 'GET_BUYER_PERIODIC_INFO'
export const GET_BUYER_PERIODIC_INFO_SUCCESS = 'GET_BUYER_PERIODIC_INFO_SUCCESS'
export const GET_BUYER_PERIODIC_INFO_ERROR = 'GET_BUYER_PERIODIC_INFO_ERROR'

// 定期定額付款
export const CHECKOUT_TAPPAY_PERIODIC = 'CHECKOUT_TAPPAY_PERIODIC'
export const CHECKOUT_TAPPAY_PERIODIC_SUCCESS =
  'CHECKOUT_TAPPAY_PERIODIC_SUCCESS'
export const CHECKOUT_TAPPAY_PERIODIC_ERROR = 'CHECKOUT_TAPPAY_PERIODIC_ERROR'

// 取得付款 / 提領紀錄
export const GET_OUTFLOW_HISTORIES = 'GET_OUTFLOW_HISTORIES'
export const GET_OUTFLOW_HISTORIES_SUCCESS = 'GET_OUTFLOW_HISTORIES_SUCCESS'
export const GET_OUTFLOW_HISTORIES_ERROR = 'GET_OUTFLOW_HISTORIES_ERROR'

// 取得開團紀錄
export const GET_SELLER_HISTORIES = 'GET_SELLER_HISTORIES'
export const GET_SELLER_HISTORIES_SUCCESS = 'GET_SELLER_HISTORIES_SUCCESS'
export const GET_SELLER_HISTORIES_ERROR = 'GET_SELLER_HISTORIES_ERROR'

// 取得開團明細
export const GET_SELLER_HISTORY_DETAIL = 'GET_SELLER_HISTORY_DETAIL'
export const GET_SELLER_HISTORY_DETAIL_SUCCESS =
  'GET_SELLER_HISTORY_DETAIL_SUCCESS'
export const GET_SELLER_HISTORY_DETAIL_ERROR = 'GET_SELLER_HISTORY_DETAIL_ERROR'

// 取得分期紀錄
export const GET_INSTALMENT_HISTORIES = 'GET_INSTALMENT_HISTORIES'
export const GET_INSTALMENT_HISTORIES_SUCCESS =
  'GET_INSTALMENT_HISTORIES_SUCCESS'
export const GET_INSTALMENT_HISTORIES_ERROR = 'GET_INSTALMENT_HISTORIES_ERROR'

// 取得付款紀錄詳細資訊
export const GET_OUTFLOW_PAYMENT_DETAIL = 'GET_OUTFLOW_PAYMENT_DETAIL'
export const GET_OUTFLOW_PAYMENT_DETAIL_SUCCESS =
  'GET_OUTFLOW_PAYMENT_DETAIL_SUCCESS'
export const GET_OUTFLOW_PAYMENT_DETAIL_ERROR =
  'GET_OUTFLOW_PAYMENT_DETAIL_ERROR'

// 取得提領紀錄詳細資訊
export const GET_OUTFLOW_WITHDRAW_DETAIL = 'GET_OUTFLOW_WITHDRAW_DETAIL'
export const GET_OUTFLOW_WITHDRAW_DETAIL_SUCCESS =
  'GET_OUTFLOW_WITHDRAW_DETAIL_SUCCESS'
export const GET_OUTFLOW_WITHDRAW_DETAIL_ERROR =
  'GET_OUTFLOW_WITHDRAW_DETAIL_ERROR'

// 取得收款紀錄
export const GET_INFLOW_HISTORIES = 'GET_INFLOW_HISTORIES'
export const GET_INFLOW_HISTORIES_SUCCESS = 'GET_INFLOW_HISTORIES_SUCCESS'
export const GET_INFLOW_HISTORIES_ERROR = 'GET_INFLOW_HISTORIES_ERROR'

// 取得收款紀錄詳細資訊
export const GET_INFLOW_HISTORY_DETAIL = 'GET_INFLOW_HISTORY_DETAIL'
export const GET_INFLOW_HISTORY_DETAIL_SUCCESS =
  'GET_INFLOW_HISTORY_DETAIL_SUCCESS'
export const GET_INFLOW_HISTORY_DETAIL_ERROR = 'GET_INFLOW_HISTORY_DETAIL_ERROR'

// 逾期款項付款
export const CHECKOUT_TAPPAY_INSTALMENT = 'CHECKOUT_TAPPAY_INSTALMENT'
export const CHECKOUT_TAPPAY_INSTALMENT_SUCCESS =
  'CHECKOUT_TAPPAY_INSTALMENT_SUCCESS'
export const CHECKOUT_TAPPAY_INSTALMENT_ERROR =
  'CHECKOUT_TAPPAY_INSTALMENT_ERROR'

// 取得非會員付款頁面資訊
export const GET_PAYMENT_INFO_GUEST = 'GET_PAYMENT_INFO_GUEST'
export const GET_PAYMENT_INFO_GUEST_SUCCESS = 'GET_PAYMENT_INFO_GUEST_SUCCESS'
export const GET_PAYMENT_INFO_GUEST_ERROR = 'GET_PAYMENT_INFO_GUEST_ERROR'

// 取得會員付款頁面資訊
export const GET_PAYMENT_INFO_MEMBER = 'GET_PAYMENT_INFO_MEMBER'
export const GET_PAYMENT_INFO_MEMBER_SUCCESS = 'GET_PAYMENT_INFO_MEMBER_SUCCESS'
export const GET_PAYMENT_INFO_MEMBER_ERROR = 'GET_PAYMENT_INFO_MEMBER_ERROR'
export const GET_PAYMENT_INFO_MEMBER_ERROR_IDENTICAL =
  'GET_PAYMENT_INFO_MEMBER_ERROR_IDENTICAL'
export const GET_PAYMENT_INFO_MEMBER_ERROR_AIFI_OWNER_EXCLUSIVE =
  'GET_PAYMENT_INFO_MEMBER_ERROR_AIFI_OWNER_EXCLUSIVE'

export const SET_DASHBOARD_SEARCH_PARAMS = 'SET_DASHBOARD_SEARCH_PARAMS'

export const SET_SLASH_ACTIVE = 'SET_SLASH_ACTIVE'
export const SET_ITEM_UNAVAILABLE = 'SET_ITEM_UNAVAILABLE'
export const TERMINATE_ITEM = 'TERMINATE_ITEM'
